export const config = {
    apiKey: '39920505-4f9f-44dc-b381-0495728fb954',
    apiUrl: {
        getPoints: 'https://free-pee-default-rtdb.firebaseio.com/points.json',
        addFeedback: 'https://free-pee-default-rtdb.firebaseio.com/info.json'
    },
    tomskCenter: [56.50, 84.99],
    isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
    adminMode: true
}